import React, { useRef } from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { Remember } from './components/sections/Remember';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { PainPoints } from './components/sections/PainPoints';
import { Volumes } from './components/sections/Volumes';
import { ControlCenter } from './components/sections/ControlCenter';
import { Bonuses } from './components/sections/Bonuses';
import { Offer } from './components/sections/Offer';
import { Guarantee } from './components/sections/Guarantee';
import { Method } from './components/sections/Method';
import { Author } from './components/sections/Author';
import { Testimonials } from './components/sections/Testimonials';
import { WhatYouGet } from './components/sections/WhatYouGet';
import { FAQ } from './components/sections/FAQ';
import { FinalCTA } from './components/sections/FinalCTA';
import { Footer } from './components/sections/Footer';
export function App() {
  const heroCtaRef = useRef<HTMLDivElement>(null);
  return <div className="w-full overflow-x-hidden bg-white font-sans text-navy-800" data-id="element-0" data-mp="3rcj8i7wbs999">
      <MetaPixel data-id="element-1" data-mp="3relwynhtxubv" />

      <main data-id="element-2" data-mp="5opww5kum4f">
        <Hero ctaRef={heroCtaRef} data-id="element-3" data-mp="680tswt8a8y" />
        <Remember data-id="element-4" data-mp="56ntiw8hdol" />
        <BeforeAfter data-id="element-5" data-mp="7suzhf7pr6a" />
        <PainPoints data-id="element-6" data-mp="2zld259q0hfbj" />
        <Volumes data-id="element-7" data-mp="2zlv32jnmchps" />
        <ControlCenter data-id="element-8" data-mp="2zmem63p09c5e" />
        <Bonuses data-id="element-9" data-mp="2zn6bwxvx8fnr" />
        <Offer data-id="element-10" data-mp="33movnqc0akp0" />
        <Guarantee data-id="element-11" data-mp="33m5a7zn5de68" />
        <Method data-id="element-12" data-mp="33nq4do5juv3k" />
        <Author data-id="element-13" data-mp="33n6y54p9hv5d" />
        <Testimonials data-id="element-14" data-mp="33orik1hv3xpi" />
        <WhatYouGet data-id="element-15" data-mp="38lrrqla0dgku" />
        <FAQ data-id="element-16" data-mp="38li95irambp6" />
        <FinalCTA data-id="element-17" data-mp="38kqau06b9zv7" />
      </main>

      <Footer data-id="element-18" data-mp="38nup5qdhqbzl" />

      <FloatingCTA triggerRef={heroCtaRef} data-id="element-19" data-mp="38o4ct7b2c724" />
      <PurchasePopup data-id="element-20" data-mp="3dlw542fmdv6u" />
    </div>;
}